import { combineReducers } from 'redux';

import filters from './filters';
import balance from './balance';
import subsidies from './subsidies';
import sales from './sales';

export default combineReducers({ filters, balance, subsidies, sales });
